export default __webpack_public_path__ + "static/media/cambridge-campus-sm.08e05a24.jpg";